var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { I18NLink, t, Translate } from "../../I18N";
import { checkThesaurusCanBeDeleted, deleteThesaurus } from "../../Thesauri/actions/thesaurisActions";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon } from "../../UI";
import { SettingsHeader } from "./SettingsHeader";
import sortThesauri from "../utils/sortThesauri";

class ThesauriList extends Component {
  getThesaurusSuggestionActions(thesaurus) {
    const showSuggestions =
    this.props.topicClassificationEnabled || thesaurus.enable_classification;
    return (
      showSuggestions && /*#__PURE__*/
      _jsx("div", { className: "vertical-line" }, void 0,
      thesaurus.enable_classification && /*#__PURE__*/
      _jsx("span", { className: "thesaurus-suggestion-count" }, void 0,
      thesaurus.suggestions ? thesaurus.suggestions.toLocaleString() : 'No', "\xA0",
      t('System', 'documents to be reviewed')), /*#__PURE__*/


      _jsx(I18NLink, {
        to: `/settings/dictionaries/cockpit/${thesaurus._id}`,
        className: "btn btn-default btn-xs" }, void 0, /*#__PURE__*/

      _jsx("span", {}, void 0, t('System', 'Configure suggestions')))));




  }

  getThesaurusModifyActions(thesaurus) {
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: `/settings/dictionaries/edit/${thesaurus._id}`,
        className: "btn btn-default btn-xs",
        confirmTitle:
        thesaurus.enable_classification ? 'Confirm edit suggestion-enabled Thesaurus' : '',

        confirmMessage:
        thesaurus.enable_classification ?
        'Uwazi suggests labels based on the current content of the document collection and its metadata. ' +
        'Editing this thesaurus, the content of the documents or other metadata can affect Uwazi’s understanding of what to suggest.' :
        '' }, void 0, /*#__PURE__*/


      _jsx(Icon, { icon: "pencil-alt" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, t('System', 'Edit'))),

      '  ', /*#__PURE__*/
      _jsx("button", {
        onClick: this.deleteThesaurus.bind(this, thesaurus),
        className: "btn btn-danger btn-xs template-remove",
        type: "button" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, t('System', 'Delete')))));



  }

  deleteThesaurus(thesaurus) {
    return this.props.
    checkThesaurusCanBeDeleted(thesaurus).
    then(() => {
      this.context.confirm({
        accept: () => {
          this.props.deleteThesaurus(thesaurus);
        },
        title: /*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Confirm delete thesaurus:"), "\xA0", thesaurus.name),


        message: 'Are you sure you want to delete this thesaurus?'
      });
    }).
    catch(() => {
      this.context.confirm({
        accept: () => {},
        noCancel: true,
        title: /*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Cannot delete thesaurus:\xA0"), "\xA0", thesaurus.name),


        message: 'This thesaurus is being used in document types and cannot be deleted.'
      });
    });
  }

  thesaurusNode(thesaurus) {
    return /*#__PURE__*/(
      _jsx("tr", {}, thesaurus.name, /*#__PURE__*/
      _jsx("th", { scope: "row" }, void 0, thesaurus.name), /*#__PURE__*/
      _jsx("td", {}, void 0, this.getThesaurusSuggestionActions(thesaurus)), /*#__PURE__*/
      _jsx("td", {}, void 0, this.getThesaurusModifyActions(thesaurus))));


  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "flex panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Thesauri")), /*#__PURE__*/

      _jsx("div", { className: "thesauri-list" }, void 0, /*#__PURE__*/
      _jsx("table", {}, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("th", { className: "nameCol", scope: "col" }), /*#__PURE__*/
      _jsx("th", { scope: "col" }), /*#__PURE__*/
      _jsx("th", { scope: "col" }))), /*#__PURE__*/


      _jsx("tbody", {}, void 0,
      sortThesauri(this.props.dictionaries.toJS()).map((thesaurus) =>
      this.thesaurusNode(thesaurus))))), /*#__PURE__*/




      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: "/settings/dictionaries/new", className: "btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "plus" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Add thesaurus')))))));





  }
}








ThesauriList.contextTypes = {
  confirm: PropTypes.func
};

export function mapStateToProps(state) {
  return {
    dictionaries: state.dictionaries,
    topicClassificationEnabled: (state.settings.collection.toJS().features || {}).
    topicClassification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    deleteThesaurus,
    checkThesaurusCanBeDeleted
  },
  dispatch);

}

export { ThesauriList };
export default connect(mapStateToProps, mapDispatchToProps)(ThesauriList);